import { Dispatch } from '../../../../../types/actions';
import { ISnackbarModel } from '../../store/types';
import { snackbarInfoDefault } from './infoDefault';

export const snackbarBoardInfoDefault = (
    options: ISnackbarModel
) => {
    return (dispatch: Dispatch) => {
        if (options.icon === undefined) {
            options.icon = 'board';
        }
        dispatch(snackbarInfoDefault(options));
    }
};
